import { render, staticRenderFns } from "./my-exam.vue?vue&type=template&id=67a441d6&scoped=true&"
import script from "./my-exam.vue?vue&type=script&lang=js&"
export * from "./my-exam.vue?vue&type=script&lang=js&"
import style0 from "./my-exam.vue?vue&type=style&index=0&id=67a441d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a441d6",
  null
  
)

export default component.exports